import React from "react";
import {Navigate} from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import BusinessDashboard from "./BusinessDashboard";

const BusinessDashboardRoute = () => {
    const {authUser} = useJumboAuth();

    if (!authUser) return null;

    if (authUser.current_company?.id === 80) {
        return <Navigate to="/dashboard" replace/>;
    }

    return <BusinessDashboard/>;
};

export default BusinessDashboardRoute;
